import { render, staticRenderFns } from "./LicenseOrderCopyShow.vue?vue&type=template&id=5a21edae&"
import script from "./LicenseOrderCopyShow.vue?vue&type=script&lang=ts&"
export * from "./LicenseOrderCopyShow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports